import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import Fundo from "../../imagens/fundo-qrpedir-min.png";
import Robo from "../../imagens/roboError.svg";

const TelaInativo = () => {
  const handleReturn = () => {
    window.location.href = process.env.REACT_APP_STATION_URL;
  };

  const styles = {
    fundo: {
      height: "100vh",
      background: `url(${Fundo}) repeat`,
    },
  };

  return (
    <Box
      style={styles.fundo}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Container fixed style={{ display: "flex", justifyContent: "center" }}>
        <img src={Robo} style={{ width: "30%" }} alt="Robo erro" />

        <Box
          style={{
            marginLeft: "30px",
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
          }}
        >
          <Typography
            align="center"
            style={{ fontSize: "150%", marginTop: "10px" }}
          >
            Espera aí, parece que seu sistema foi Inativado! <br />
            Entre em contato com nosso suporte para tirar suas <br /> dúvidas.
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Typography align="center" style={{ fontSize: "100%" }}>
              Central de atendimento:{" "}
              <a href="https://qrpedir.com/suporte/">qrpedir.com/suporte/</a>{" "}
              <br />
              Telefone: (46) 3199-0986.
            </Typography>
            <Button
              onClick={handleReturn}
              style={{ width: "170px", margin: "10px auto" }}
              variant="contained"
              color="primary"
            >
              Voltar ao início
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default TelaInativo;
